import { useState } from "react";
import { Button, Card, Form, Input, message } from "antd";
import { ChevronRight } from "lucide-react";

import { createContractor } from "sr/utils/api/company/workorder/createContractor";
import { InputNumberFormat } from "sr/helpers/functions/InputNumberFormat";

function Step1(props: any) {
  const [isLoading2, setIsLoading2] = useState(false);

  const submit = async (values: any) => {
    try {
      if (props?.data?.id) {
        props?.onChange(props?.data);
      } else {
        setIsLoading2(true);
        let payLoad = {
          company_id: props?.company_id,
          email: values?.email,
          first_name: values?.first_name,
          last_name: values?.last_name,
          mobile_number: values?.mobile_number,
          status: "pending",
        };
        const response = await createContractor(payLoad);
        if (response.success) {
          props?.onChange(response?.data);
        } else {
          message.error("Failed to create contractor");
        }
      }
    } catch (err) {
      setIsLoading2(false);
      message.error("Something went wrong");
      console.log("error = = = >", err);
    }
  };

  return (
    <div className="mt-6 mx-auto max-w-4xl pb-40">
      <Form
        layout="vertical"
        onFinish={submit}
        initialValues={{
          first_name: props?.data?.first_name,
          last_name: props?.data?.last_name,
          email: props?.data?.email,
          mobile_number: props?.data?.mobile_number,
        }}
      >
        <Card title="Contractor Information" headStyle={{ padding: 10 }}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Form.Item
              label="First Name"
              name={"first_name"}
              rules={[{ required: true, message: "First name is required" }]}
            >
              <Input size="large" placeholder="Enter first name" />
            </Form.Item>
            <Form.Item
              label="Last Name"
              name={"last_name"}
              rules={[{ required: true, message: "Last name is required" }]}
            >
              <Input size="large" placeholder="Enter last name" />
            </Form.Item>
          </div>
          <Form.Item
            label="Email Address"
            name={"email"}
            rules={[{ required: true, message: "Email is required" }]}
          >
            <Input size="large" placeholder="Enter email address" />
          </Form.Item>
          <Form.Item
            label="Phone Number"
            name={"mobile_number"}
            rules={[{ required: true, message: "Phone number is required" }]}
            getValueFromEvent={(event) => event.target.value.replace(/\D/g, "")}
            getValueProps={(value) => ({
              value: InputNumberFormat(value || ""),
            })}
          >
            <Input
              size="large"
              placeholder="Enter phone number"
              type="tel"
              inputMode="numeric"
              autoComplete="tel"
            />
          </Form.Item>
        </Card>
        <div className="fixed bottom-0 left-0 right-0 bg-white backdrop-blur-sm border-t border-gray-200 z-1000 p-2 !pl-0 sm:!pl-[200px]">
          <div className="flex items-center mx-auto sm:max-w-4xl">
            <div>
              <Button
                size="large"
                danger
                className="!px-10"
                onClick={() => props?.onBack()}
              >
                Close
              </Button>
            </div>
            <div className="flex-1"></div>
            <div>
              <Button
                size="large"
                type="primary"
                className="!px-10"
                htmlType="submit"
                loading={isLoading2}
              >
                Next <ChevronRight size={20} />
              </Button>
            </div>
          </div>
        </div>
      </Form>
    </div>
  );
}

export default Step1;
